export enum siteRoutes {
  loginType = "/auth/login-type",
  registerInfo = "/auth/register-info",
  login = "/auth/login",
  otpVerification = "/auth/otp-verification",
  resetPassword = "/auth/reset-password",
  signUp = "/auth/sign-up",
  ambassadorRole = "/auth/ambassador-role",

  home = "/",
  experiences = "/experiences",
  experienceDetail = "/experience-detail",
  attendess = "/attendess",
  createExperience = "/create-experience",
  communities = "/communities",
  hostProfile = "/host-profile",
  editProfile = "/edit-profile",
  subscription = "/subscription",
  resourceLibrary = "/resource-library",
  myBadges = "/my-badges",
  myRepresentatives = "/my-representatives",
  myRating = "/my-ratings",
  reviewsCups = "/reviews-cups",
  generalSettings = "/general-setting",
  managePayments = "/manage-payment",
  createBadge="/create-badge",
  createBadges="/create-badges",
  hostEventBadges="/host-event-badges",
  myCancelledTickets="/my-cancelled-tickets",
  hostMobileSubscription ="/host-mobile-subscription",

  // Attendee
  attendeeHome = "/attendee/home",
  parentGuardianDetails = "/attendee/parent-guardian-details",
  familyInformation = "/attendee/family-information",
  declarationForm = "/attendee/declaration-form",
  attendeeExperiences = "/attendee/experiences",
  editAttendeeProfile = "/attendee/edit-profile",
  generalSettingsAttendee = "/attendee/general-settings",
  attendeeCommunities = "/attendee/communities",
  familyMembers = "/attendee/family-members",
  experiencesDetailAttendee = "/attendee/experiences-detail",
  ratings = "/attendee/ratings",
  signedUpExperienceAttendee = "/attendee/signed-experience",
  attendeeJoining = "/attendee/joining",
  attendeeJoinAndPay = "/attendee/join-and-pay",

  
  attendeeHostProfileDetail = "/attendee/host-profile-detail",
  familyDetail = "/attendee/family-detail",
  attendeePasses = "/attendee/passes",
  attendeeResourceLibrary = "/attendee/resource-library",
  attendeeFavoriteHosts = "/attendee/favorite-hosts",
  familyDetailAssessment = "/attendee/family-detail/assessment/learning-style",
  assessmentLearningSkills = "/attendee/family-detail/assessment/learning-skills",

  // Minors
  minorHome = "/minor/home",
  minorExperiences = "/minor/experiences",
  minorExperienceDetail = "/minor/experience-detail",
  minorDigitalPassport = "/minor/digital-passport",
  minorFavoriteHost = "/minor/favorite-host",
  minorGeneralSettings = "/minor/general-setting",
  minorEditProfile = "/minor/edit-profile",
  minorExperiencesDetail = "/minor/experience-detail",
  minorRatings = "/minor/ratings",
  minorTicket = "/minor/ticket",
  minorProfileDetailHost = "/minor/profile-detail-host",
  minorEventRatings = "/minor/event-ratings",

  // Ambassador
  ambassadorHome = "/ambassador/home",
  ambassadorProfile = "/ambassador/profile",
  ambassadorEditProfile = "/ambassador/edit-profile",
  ambassadorWelcome = "/ambassador/welcome",
  ambassadorGeneralSettings = "/ambassador/general-settings",
  ambassadorExperiences = "/ambassador/experiences",
  ambassadorExperiencesDetail = "/ambassador/experiences-details",
  ambassadorResourceLibrary = "/ambassador/resource-library",
  ambassadorRedeemPrizePoints = "/ambassador/redeem-prize-points",
  ambassadorFamilyprofile = "/ambassador/family-profile",
  ambassadorMyBadges = "/ambassador/my-badges",
  ambassadorWallet = "/ambassador/wallet",
  ambassadorfollowExperiences = "/ambassador/follow-up-experiences",
  ambassadorJoinEvents = "/ambassador/join-events",
  ambassadorCommunities = "/ambassador/communities",
  ambassadorAdminExperienceDetail = "/ambassador/admin-experience-detail",



  // Rsvp
  rsvpHome = "/rsvp/home",
  rsvpExperiences = "/rsvp/experiences",
  rsvpEditProfile = "/rsvp/edit-profile",
  rsvpExperiencesDetail = "/rsvp/experiences-detail",
  rsvpHostProfileDetail = "/rsvp/host-profile-detail",
  rsvpMyBadges = "/rsvp/my-badges",
  rsvpGeneralSettings = "/rsvp/general-settings",
  rsvpAttendess = "/rsvp/attendess",
  rsvpRatings = "/rsvp/ratings",
  rsvpRating = "/rsvp/rating",
  rsvpViewRatings = "/rsvp/view-ratings",
  rsvpCommunities = "/rsvp/communities",
}
